const borderCollapse = {
  name: "border-collapse",
  path: "/border-collapse",
  title: "border-collapse",
  description: "Utilities for controlling table border collapse.",
  value: {
    'border-collapse': {
      'border-collapse': 'collapse;',
      'border-separate': 'separate;',
    },
  },
  exampleData: [
    {
      example: {
        code: `<table class="border-collapse w-full">
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">A</td>
    <td class="border border-color-gray-300 px-4 py-2">B</td>
  </tr>
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">C</td>
    <td class="border border-color-gray-300 px-4 py-2">D</td>
  </tr>
</table>
<table class="border-separate w-full mt-6">
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">A</td>
    <td class="border border-color-gray-300 px-4 py-2">B</td>
  </tr>
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">C</td>
    <td class="border border-color-gray-300 px-4 py-2">D</td>
  </tr>
</table>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">border-collapse</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">border-separate</code> to control table border rendering.
      </p>
      <p class="mb-2 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">border-collapse</p>
      <div class="flex flex-col">
        <table class="border-collapse w-full">
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">A</td>
            <td class="border border-color-gray-300 px-4 py-2">B</td>
          </tr>
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">C</td>
            <td class="border border-color-gray-300 px-4 py-2">D</td>
          </tr>
        </table>
        <p class="mb-2 mt-8 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">border-separate</p>
        <table class="border-separate w-full">
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">A</td>
            <td class="border border-color-gray-300 px-4 py-2">B</td>
          </tr>
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">C</td>
            <td class="border border-color-gray-300 px-4 py-2">D</td>
          </tr>
        </table>
      </div>
      `
    }
  ]
};

export default borderCollapse;